import React from 'react';

export default React.createClass({
    propTypes: {
        defaultInputValue: React.PropTypes.string,    
        isDisabled: React.PropTypes.bool.isRequired,   
        id: React.PropTypes.number.isRequired,
		index: React.PropTypes.number.isRequired,
		isPlayed: React.PropTypes.bool.isRequired,
        personalPar: React.PropTypes.number.isRequired,
        par: React.PropTypes.number.isRequired,
        onClick: React.PropTypes.func.isRequired,
        selected: React.PropTypes.bool.isRequired,
        tabIndex: React.PropTypes.number.isRequired,
        numberOfStrokes: React.PropTypes.oneOfType([
            React.PropTypes.string,
            React.PropTypes.number
        ]).isRequired
    },
    componentDidMount() {
        this.props.onChange(this.props.index, this.state.counter);    
    },
    getInitialState() {
        return {
            counter: this.props.numberOfStrokes,
            birdie: false,
			eagle: false
        };
    },
    handleCountUp() {
        let count = parseInt(this.state.counter)+1;

        this.setState({
			counter: count
        });

        this.props.onChange(this.props.index, count);
    },
	handleCountDown() {
        if (this.state.counter > 0) {
            let count = parseInt(this.state.counter) - 1;
            this.setState({
                counter: count
            });
            this.props.onChange(this.props.index, count);
        }
    },
    handleKeyUp(e) {
        if (e.which === 38) {
            this.handleCountUp(e);
        } else if (e.which === 40) {
            this.handleCountDown(e);
        }

        if (e.target.value === '') {
            this.setState({
				counter: 0
            });
        }
    },
    handleChange(e) {
        let count = Number(e.target.value.replace(/[^0-9+/]/g, '') || -1);

        this.setState({
			counter: count
        });

        this.props.onChange(this.props.index, count);
    },
    handleBlur(e) {
        if (e.target.value === '') {
            this.setState({
				counter: 0
            });
            this.props.onChange(this.props.index, 0);
        }
    },
    handleRowClick() {
        this.props.onClick(this.props.index);
    },
    renderPersonalPar() {
        let value = parseInt(this.props.personalPar) - parseInt(this.props.par);
        if (value > 0) {
            return (
                <sup>+{value}</sup>
            );
        } else if (value < 0) {
            return (
                <sup>{value}</sup>
            )
        }
    },
	render() {
		const score = String(this.props.numberOfStrokes).replace(/^0.*/, this.props.defaultInputValue).replace(/^-1.*/, ''), 
            hideDecreaseClass = (parseInt(this.props.numberOfStrokes) === 0) ? 'u-hidden' : '',
            focusClass = (this.props.selected) ? '-focus' : '';

        return (
            <tr className={`${focusClass}`} onClick={this.handleRowClick}>
                <td>{this.props.index+1}</td>
                <td>{this.props.par}{this.renderPersonalPar()}</td>
                <td>
                    <div className="c-scorecard__scores__score">
                        <button type="button" className={`c-scorecard__scores__down ${hideDecreaseClass}`} onClick={this.handleCountDown} disabled={this.props.isDisabled}>-</button>
                        <div className={`c-scorecard__scores__input`}>
                            {/*
                            prepend 'id' to the name attribute because input names cannot be numbers only
                            we'll strip this of before submitting the form data
                             */}
                            <input
                                name={`id${this.props.id}`}
                                ref="input"
                                type="text"
                                value={score}
                                tabIndex={this.props.tabIndex+1}
                                onChange={this.handleChange}
                                onBlur={this.handleBlur}
                                onKeyUp={this.handleKeyUp}
                                onFocus={this.handleRowClick}
                                disabled={this.props.isDisabled}
                            />
                        </div>
                        <button type="button" className="c-scorecard__scores__up" onClick={this.handleCountUp} disabled={this.props.isDisabled}>+</button>
                    </div>
                </td>
            </tr>
        );
    }    
});
